import type { Overview } from "./admin-types";

export function formatDate(value: string | null) {
  if (!value) return "—";
  return new Intl.DateTimeFormat("tr-TR", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
}

export function adminOverviewMetrics(data: Overview | null) {
  const metrics = [
    ["Toplam kullanıcı", data?.users ?? "—", "Uygulama kayıtları"],
    ["İlk giriş bekleyen", data?.pendingUsers ?? "—", "Eşleşme bekliyor"],
    ["Aktif oturum", data?.activeSessions ?? "—", "Süresi dolmamış"],
    ["Bildirim hatası", data?.failedNotifications ?? "—", "Yeniden denenecek"],
    ["Güvenlik olayı", data?.securityEvents ?? "—", "Son 24 saat"],
  ];
  return metrics;
}
